import { render, staticRenderFns } from "./popSendCode.vue?vue&type=template&id=4b9eccb3&scoped=true"
import script from "./popSendCode.vue?vue&type=script&lang=js"
export * from "./popSendCode.vue?vue&type=script&lang=js"
import style0 from "./popSendCode.vue?vue&type=style&index=0&id=4b9eccb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9eccb3",
  null
  
)

export default component.exports